module.exports = __webpack_public_path__ + "img/2406.caac3507.gif";